import "./NoInternetComponent.scss";
import React, {useEffect, useState} from "react";
import {ImageConfig} from "../../../constants";
import RefreshIcon from '@mui/icons-material/Refresh';
import ButtonComponent from "../core/button/ButtonComponent";
import LottieFileGenarationComponent from "../core/lottie-file-genaration/LottieFileGenarationComponent";

const NoInternetComponent = (props: React.PropsWithChildren<any>) => {
    const [isOffline, setIsOffline] = useState(false);
    useEffect(() => {
        const handleOnline = () => {
            setIsOffline(false);
        };

        const handleOffline = () => {
            setIsOffline(true);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Clean up event listeners when the component unmounts
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    const retryConnection = () => {
        window.location.reload();
    }

    return (
        <>
            {isOffline ?
                <div className={'no-internet-component'}>
                    <div className={'lottie-wrapper'}>
                        <LottieFileGenarationComponent
                            height={'200px'}
                            width={'200px'}
                            loop={true}
                            autoplay={true}
                            animationData={ImageConfig.noInternetLottie}/>
                    </div>
                    <div className={'no-internet-title'}>
                        No internet connection!
                    </div>
                    <div className={'no-internet-description'}>
                        Oops! Seems like we lost you. Check that your device is connected to the internet, and then try
                        again.
                    </div>
                    <div className={'refresh-page-action-wrapper'}>
                        <ButtonComponent
                            startIcon={<RefreshIcon/>}
                            handleClick={() => retryConnection()}
                            variant={"contained"}
                            color={"primary"}
                        >
                            Try Again
                        </ButtonComponent>
                    </div>

                </div>
                :
                props.children
            }
        </>
    );

};

export default NoInternetComponent;
